'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.yearsSince;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/yearsSince.js
// module id = 366
// module chunks = 0